
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle, Clock, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FEATURED_COURSES } from '@/data/catalogue-stats';

const TrainingCertifications = () => {
  const courses = FEATURED_COURSES;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white w-full overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#422680] via-[#660F56] to-[#F54952] bg-clip-text text-transparent">
              Training & Certifications
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Practitioner-led training across Copilot, Purview and SharePoint — built for Australian organisations.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-[#422680] hover:shadow-2xl transition-all group flex flex-col h-full"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={course.image} 
                  alt={`${course.title} certification training program`} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-[#F54952] text-white text-xs font-bold px-3 py-1 rounded-full">
                  {course.level}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{course.title}</h3>
                <div className="space-y-2 mb-6 flex-1">
                  <div className="flex items-center gap-2 text-gray-600">
                    <Clock size={16} className="text-[#422680]" />
                    <span className="text-sm">{course.duration}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-600">
                    <Users size={16} className="text-[#422680]" />
                    {/* See CoursePage.jsx — "New" is a sentinel, not a count. */}
                    <span className="text-sm">
                      {course.students === 'New' ? 'New course' : `${course.students} enrolled`}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-600">
                    <CheckCircle size={16} className="text-[#422680]" />
                    <span className="text-sm">Certification included</span>
                  </div>
                </div>
                <Link to={`/training/${course.slug}`} className="mt-auto" aria-label={`Learn more about ${course.title} training`}>
                  <Button
                    className="w-full bg-gradient-to-r from-[#422680] to-[#F54952] hover:opacity-90 text-white"
                  >
                    Learn More
                  </Button>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainingCertifications;
